import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import PostBacksContext from '@/modules/pb/contexts/PostBacksContext';
import Button from '@/modules/common/components/Button';
import ButtonGroup from '@/modules/common/components/ButtonGroup';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';

const Top = (props) => {
    const pbContext = useContext(PostBacksContext);

    return (
        <ContentBodyTop
            left={
                <Button onClick={props.onClickAdd}>Добавить</Button>
            }
            right={
                <form id="form-filter" onSubmit={props.onSubmitFilter}>
                    <ButtonGroup>
                        {(pbContext.isFiltered)
                            ? <Button onClick={props.onClickResetFilter}>Очистить фильтр</Button>
                            : null
                        }
                        <Button type="submit">Применить фильтр</Button>
                    </ButtonGroup>
                </form>
            }
        />
    );
};

Top.propTypes = {
    onClickAdd: PropTypes.func.isRequired,
    onClickResetFilter: PropTypes.func.isRequired,
    onSubmitFilter: PropTypes.func.isRequired,
}

export default Top;
